import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import AssetImage from '../BaseComponents/Image/Asset'
import Icons from './IconHelper'

const PushSettingsGuide: FunctionComponent = (): ReactElement => {
    const { settingsIcon, notificationsIcon, appIcon } = Icons
    return (
        <Grid horizontal noExpand center>
            <AssetImage height={29} width={29} resizeMode="contain" imageUrl={settingsIcon} />
            <Grid noExpand marginX={3}>
                <FontelloIcon name="scroll-right" fontSize={13} />
            </Grid>
            <AssetImage height={29} width={29} resizeMode="contain" imageUrl={notificationsIcon} />
            <Grid noExpand marginX={3}>
                <FontelloIcon name="scroll-right" fontSize={13} />
            </Grid>
            <AssetImage height={29} width={29} resizeMode="contain" imageUrl={appIcon} />
        </Grid>
    )
}
export default PushSettingsGuide
